import { render, staticRenderFns } from "./text-fragment-results.vue?vue&type=template&id=0551369f&scoped=true&"
import script from "./text-fragment-results.vue?vue&type=script&lang=ts&"
export * from "./text-fragment-results.vue?vue&type=script&lang=ts&"
import style0 from "./text-fragment-results.vue?vue&type=style&index=0&id=0551369f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0551369f",
  null
  
)

export default component.exports